'use client';

import { LogIn } from 'lucide-react';
import { signInAndReturn } from '@/lib/campus';
import { Bar, CARD, CTA_TEAL, DISPLAY } from './ui';

/** The shape of the header while /me loads: the heading, then a face and a name. */
export function HeroSkeleton() {
  return (
    <div className="flex flex-col gap-6" aria-busy="true">
      <Bar className="h-14 w-48" />
      <div className="flex items-center gap-5 @xl:gap-7">
        <div className="h-32 w-32 shrink-0 animate-pulse rounded-full bg-gray-200" />
        <div className="flex flex-col gap-3">
          <Bar className="h-12 w-72" />
          <Bar className="h-4 w-24" />
        </div>
      </div>
    </div>
  );
}

/** Signed out: one card, one button. The header's login modal opens, or MP's hosted sign-in with a round trip. */
export function SignedOutCard({ mock }: { mock: boolean }) {
  return (
    <div className={`${CARD} flex flex-col items-center gap-4 px-6 py-14 text-center`}>
      <p className={`${DISPLAY} text-4xl leading-none text-[#1c2b39] sm:text-5xl`}>
        Sign in to see your profile
      </p>
      <p className="max-w-md text-sm text-gray-600">
        Your household, your groups, your giving and your subscriptions live here. Sign in and we'll
        bring you right back.
      </p>
      <button
        type="button"
        onClick={() => {
          if (mock) window.location.assign(window.location.pathname + '?mock=1');
          else signInAndReturn();
        }}
        className={CTA_TEAL}
      >
        Sign in
        <LogIn className="h-4 w-4" strokeWidth={2.5} />
      </button>
    </div>
  );
}
